import { Stack } from '@mui/material';
import React from 'react';
import { Label } from './label';
import { Value } from './value';

interface Props {
  label: string;
  value: React.ReactNode;
  testId?: string;
  spacing?: number;
}

export function ViewLabelValue({ label, value, testId, spacing }: Props) {
  return (
    <Stack spacing={spacing}>
      <Label>{label}</Label>
      <Value testId={testId}>{value}</Value>
    </Stack>
  );
}
